export default __webpack_public_path__ + "static/media/ic-sold-coin.2402eb9a.svg";